import { ContainerAcoes, Conteiner, Conteudo, Divisor, Cabecalho } from './styles';

export function Modal({ children, titulo = '', acoes, controleAberturaModal }) {
  return (
    <Conteiner
      onClick={() => {
        controleAberturaModal();
      }}
    >
      <Conteudo
        onClick={(evento) => {
          evento.stopPropagation();
        }}
      >
        <Cabecalho>
          <h4>{titulo}</h4>
          <Divisor />
          {children}
          <Divisor />
          {acoes && <ContainerAcoes>{acoes}</ContainerAcoes>}
        </Cabecalho>
      </Conteudo>
    </Conteiner>
  );
}
